export var NotificationParticipantFiltersOrderItemGroupItemType;
(function (NotificationParticipantFiltersOrderItemGroupItemType) {
    NotificationParticipantFiltersOrderItemGroupItemType["GROUP"] = "product_group";
    NotificationParticipantFiltersOrderItemGroupItemType["PRODUCT"] = "product";
})(NotificationParticipantFiltersOrderItemGroupItemType || (NotificationParticipantFiltersOrderItemGroupItemType = {}));
export var NotificationParticipantFiltersAreaItemType;
(function (NotificationParticipantFiltersAreaItemType) {
    NotificationParticipantFiltersAreaItemType[NotificationParticipantFiltersAreaItemType["CIRCLE"] = 1] = "CIRCLE";
    NotificationParticipantFiltersAreaItemType[NotificationParticipantFiltersAreaItemType["POLYGON"] = 2] = "POLYGON";
})(NotificationParticipantFiltersAreaItemType || (NotificationParticipantFiltersAreaItemType = {}));
export var NotificationParticipantFiltersAreaType;
(function (NotificationParticipantFiltersAreaType) {
    NotificationParticipantFiltersAreaType[NotificationParticipantFiltersAreaType["ARRANGE_PLACE"] = 1] = "ARRANGE_PLACE";
    NotificationParticipantFiltersAreaType[NotificationParticipantFiltersAreaType["DELIVERY_ADDRESSES"] = 2] = "DELIVERY_ADDRESSES";
})(NotificationParticipantFiltersAreaType || (NotificationParticipantFiltersAreaType = {}));
export const appLinkTypeEnum = {
    EXTERNAL_LINK: 'external_link',
    APP_BONUSES_PAGE: 'app_bonuses_page',
    APP_PROMO_PAGE: 'app_promo_page',
    APP_PRODUCT_PAGE: 'app_product_page'
};
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus[NotificationStatus["CREATED"] = 1] = "CREATED";
    NotificationStatus[NotificationStatus["GENERATING_RECIPIENTS"] = 2] = "GENERATING_RECIPIENTS";
    NotificationStatus[NotificationStatus["READY_TO_SEND"] = 3] = "READY_TO_SEND";
})(NotificationStatus || (NotificationStatus = {}));
export const notificationStatusEnum = {
    CREATED: NotificationStatus.CREATED,
    GENERATING_RECIPIENTS: NotificationStatus.GENERATING_RECIPIENTS,
    READY_TO_SEND: NotificationStatus.READY_TO_SEND
};
export const notificationStatusName = {
    [NotificationStatus.CREATED]: 'Создана',
    [NotificationStatus.GENERATING_RECIPIENTS]: 'Генерация получателей',
    [NotificationStatus.READY_TO_SEND]: 'Готово к отправке'
};
export const notificationStatusList = Object.keys(notificationStatusName).map(_key => {
    const key = Number(_key);
    return {
        label: notificationStatusName[key],
        value: key
    };
});
